import { render, staticRenderFns } from "./_productType.vue?vue&type=template&id=6e2e3a3f&"
import script from "./_productType.vue?vue&type=script&lang=js&"
export * from "./_productType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports